import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { colors, fonts } from '../components/UI'

export default function ResetPasswordPage({ onDone }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (password.length < 8) { setError('Password must be at least 8 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true); setError('')
    const { error } = await supabase.auth.updateUser({ password, data: { password_set: true } })
    if (error) { setError(error.message); setLoading(false); return }
    setSuccess(true)
    setLoading(false)
    setTimeout(() => onDone(), 2000)
  }

  const inputStyle = {
    width: '100%', padding: '12px 14px',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '10px', color: colors.text,
    fontSize: '16px', fontFamily: fonts.body,
    outline: 'none', boxSizing: 'border-box',
  }

  return (
    <div style={{
      minHeight: '100vh', minHeight: '100dvh',
      background: colors.navy,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontFamily: fonts.body, padding: '24px 20px',
      paddingTop: 'max(24px, env(safe-area-inset-top))',
    }}>
      {/* Logo */}
      <div style={{ marginBottom: '32px', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '8px' }}>
          <div style={{ width: '3px', height: '52px', background: colors.gold }} />
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontFamily: fonts.body, fontWeight: 300, fontSize: '14px', letterSpacing: '0.04em', color: `rgba(${colors.textRgb},0.4)`, marginBottom: '2px' }}>THE</div>
            <div style={{ fontFamily: fonts.heading, fontWeight: 700, fontSize: '32px', letterSpacing: '0.04em', color: colors.text, lineHeight: 1 }}>INVESTING</div>
            <div style={{ fontFamily: fonts.heading, fontWeight: 300, fontSize: '16px', letterSpacing: '0.18em', color: colors.gold, lineHeight: 1.2 }}>COUPLE</div>
          </div>
        </div>
        <div style={{ fontFamily: fonts.heading, fontWeight: 700, fontSize: '16px', letterSpacing: '0.22em', color: `rgba(${colors.textRgb},0.5)`, borderTop: `1px solid rgba(201,151,43,0.2)`, paddingTop: '8px', marginTop: '4px' }}>
          BUDGET TRACKER
        </div>
      </div>

      <div style={{ width: '100%', maxWidth: '400px', background: colors.card, border: '1px solid rgba(255,255,255,0.07)', borderTop: `3px solid ${colors.gold}`, borderRadius: '12px', padding: '28px 24px' }}>
        {success ? (
          <div style={{ textAlign: 'center', padding: '12px 0' }}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>✓</div>
            <div style={{ fontSize: '16px', color: colors.green, fontFamily: fonts.heading, fontWeight: 700, letterSpacing: '0.06em', marginBottom: '8px' }}>Password updated</div>
            <div style={{ fontSize: '14px', fontWeight: 500, color: colors.muted, fontFamily: fonts.body }}>Taking you to your dashboard...</div>
          </div>
        ) : (
          <>
            <div style={{ fontSize: '20px', color: colors.text, fontFamily: fonts.heading, fontWeight: 700, letterSpacing: '0.06em', marginBottom: '4px' }}>Set New Password</div>
            <div style={{ fontSize: '14px', color: colors.muted, fontFamily: fonts.body, marginBottom: '24px' }}>Choose a strong password for your account</div>

            {error && <div style={{ background: 'rgba(224,82,82,0.1)', border: '1px solid rgba(224,82,82,0.25)', borderRadius: '10px', padding: '10px 14px', fontSize: '14px', color: '#f08080', fontFamily: fonts.body, marginBottom: '16px' }}>{error}</div>}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ display: 'block', fontSize: '14px', color: colors.muted, letterSpacing: '0.1em', fontFamily: fonts.body, fontWeight: 600, marginBottom: '6px' }}>New password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 8 characters" required style={inputStyle} />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', color: colors.muted, letterSpacing: '0.1em', fontFamily: fonts.body, fontWeight: 600, marginBottom: '6px' }}>Confirm password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat your password" required style={inputStyle} />
              </div>
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: colors.gold, border: 'none', borderRadius: '10px', color: colors.onAccent, fontSize: '14px', fontFamily: fonts.body, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', letterSpacing: '0.1em', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Updating...' : 'Update Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
